var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='FX and CFD are leveraged products that carry a high level of risk to your capital and may not be suitable for all customers.\nBased on your responses, we suggest that you gain more knowledge and experience in the products before opening up a live account.<br/><br/>\nPlease feel free to open a <a href=\'/open_account/demo_account\'>demo account</a> at Land-FX without any strings attached';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/templates/w/open_account/survey_error_message.html
// module id = 33
// module chunks = 0